import React, { useMemo } from "react";

const Milestones = ({ birthDate }) => {
  const milestones = useMemo(() => {
    // Validate birthDate
    if (!birthDate || isNaN(new Date(birthDate).getTime())) {
      return [];
    }

    const now = new Date();
    const birth = new Date(birthDate);
    
    // Calculate milestones
    const calculateMilestone = (yearsToAdd) => {
      const milestoneDate = new Date(birth);
      milestoneDate.setFullYear(birth.getFullYear() + yearsToAdd);
      const diff = milestoneDate - now;
      const daysUntil = Math.ceil(diff / (1000 * 60 * 60 * 24));
      const weeksUntil = Math.ceil(diff / (1000 * 60 * 60 * 24 * 7));
      
      return {
        age: yearsToAdd,
        date: milestoneDate.toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        }),
        daysUntil: daysUntil > 0 ? daysUntil : 0,
        weeksUntil: weeksUntil > 0 ? weeksUntil : 0,
        passed: daysUntil <= 0
      };
    };
    
    // Calculate current age
    let currentAge = now.getFullYear() - birth.getFullYear();
    const monthDiff = now.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
      currentAge--;
    }
    
    // Get next milestone (round up to next 5 or 10)
    const nextMilestoneAge = Math.ceil((currentAge + 1) / 5) * 5;
    const milestonesList = [];
    
    // Add next few milestones
    for (let age = nextMilestoneAge; age <= 60; age += 5) {
      if (age > currentAge) {
        milestonesList.push(calculateMilestone(age));
      }
    }
    
    // Always include 60
    if (currentAge < 60) {
      const age60 = calculateMilestone(60);
      if (!milestonesList.find(m => m.age === 60)) {
        milestonesList.push(age60);
      }
    }
    
    return milestonesList.slice(0, 3); // Show next 3 milestones
  }, [birthDate]);

  if (milestones.length === 0) {
    return null;
  }

  return (
    <div className="mt-12 mb-12">
      <h2 className="text-2xl font-bold text-center mb-6 text-white">
        Upcoming Milestones
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {milestones.map((milestone, index) => (
          <div
            key={index}
            className="bg-gradient-to-b from-gray-900 to-gray-800 p-6 rounded-lg shadow-lg border border-gray-700"
          >
            <div className="text-center">
              <p className="text-gray-400 text-sm mb-2">Turning {milestone.age}</p>
              <p className="text-3xl font-extrabold text-white mb-2">
                {milestone.weeksUntil.toLocaleString()}
              </p>
              <p className="text-gray-500 text-xs mb-2">weeks away</p>
              <p className="text-gray-400 text-xs mt-3">
                {milestone.daysUntil.toLocaleString()} days
              </p>
              <p className="text-gray-500 text-xs mt-1">
                On {milestone.date}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Milestones;

